/**
 * Citron luxury cart
 *
 * Deliberately small. Cart mutations (quantity, remove) stay with Horizon's
 * own <cart-items-component>; this file only handles presentation: the free
 * shipping meter, the discount disclosure, and the mobile checkout bar.
 */
(function () {
  'use strict';

  /* ======================================================================
     Free shipping progress
     ====================================================================== */

  function formatMoney(cents, bar) {
    // Uses the shop's own money_format, passed through from Liquid.
    var whole = Math.round(cents / 100);
    var amount = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = bar && bar.getAttribute('data-money-format');
    if (fmt) return fmt.replace(/\{\{\s*\w+[^}]*\}\}/, amount);
    return amount;
  }

  function updateShipping(total) {
    var bar = document.querySelector('[data-ctr-ship]');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) return;

    if (typeof total !== 'number') total = parseInt(bar.getAttribute('data-total'), 10) || 0;
    bar.setAttribute('data-total', total);

    var remaining = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));

    var fill = bar.querySelector('[data-ctr-ship-fill]');
    var text = bar.querySelector('[data-ctr-ship-text]');
    var track = bar.querySelector('.ctr-ship__track');

    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', String(pct));

    if (remaining > 0) {
      bar.classList.remove('is-unlocked');
      if (text) {
        text.textContent = (bar.getAttribute('data-message') || '').replace('[amount]', formatMoney(remaining, bar));
      }
    } else {
      bar.classList.add('is-unlocked');
      if (text) text.textContent = bar.getAttribute('data-unlocked') || '';
    }
  }

  /* ======================================================================
     Discount disclosure
     ====================================================================== */

  function bindDiscount(scope) {
    var toggle = scope.querySelector('[data-ctr-disc-toggle]');
    if (toggle && !toggle.dataset.ctrBound) {
      toggle.dataset.ctrBound = '1';
      toggle.addEventListener('click', function () {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        if (panel) panel.setAttribute('data-open', String(open));
        if (open && panel) {
          var input = panel.querySelector('[data-ctr-disc-input]');
          if (input) setTimeout(function () { input.focus(); }, 120);
        }
      });
    }

    var form = scope.querySelector('[data-ctr-disc-form]');
    if (form && !form.dataset.ctrBound) {
      form.dataset.ctrBound = '1';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('[data-ctr-disc-input]');
        var code = input && input.value ? input.value.trim() : '';
        if (!code) return;

        // Shopify validates the code on its own /discount route and returns
        // to the cart, so success and failure are both genuine.
        var cartUrl =
          window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart';
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
      });
    }
  }

  /* ======================================================================
     Mobile sticky checkout bar
     ====================================================================== */

  function bindStickyBar() {
    var bar = document.querySelector('[data-ctr-cart-bar]');
    if (!bar || bar.dataset.ctrBound) return;
    bar.dataset.ctrBound = '1';

    var checkout = document.querySelector('[data-ctr-checkout]');

    var btn = bar.querySelector('[data-ctr-cart-bar-btn]');
    if (btn && checkout) {
      btn.addEventListener('click', function () {
        checkout.click();
      });
    }

    if (!checkout || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    // Only show the bar once the real checkout button is off screen.
    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(checkout);
  }

  /* ======================================================================
     Checkout loading state
     ====================================================================== */

  function bindCheckout() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches('form[action*="/cart"]')) return;

        var btn = form.querySelector('[data-ctr-checkout]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      },
      true
    );
  }

  /* ======================================================================
     Init + re-init after Horizon re-renders the cart
     ====================================================================== */

  function init() {
    var scope = document.querySelector('.ctr-cart');
    if (!scope) return;

    updateShipping();
    bindDiscount(scope);
    bindStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      bindCheckout();
    });
  } else {
    init();
    bindCheckout();
  }

  // Horizon morphs the cart in place on quantity/remove; re-sync afterwards.
  document.addEventListener('cart:update', function (event) {
    var cart = event.detail && event.detail.resource;
    if (cart && typeof cart.total_price === 'number') {
      updateShipping(cart.total_price);
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { updateShipping(c.total_price); })
        .catch(function () {});
    }
    setTimeout(init, 60);
  });
})();
